module.exports = __webpack_public_path__ + "img/q-5-2@2x.914533e3.png";